import { createSelector } from 'reselect';

import { IIntState } from '../../../../modules/internationalization/intReducer';
import { selectInt } from '../../../../modules/internationalization/intSelectors';
import { ESubscriberIdActions } from '../../types';
import { manageNumberApi } from './store';

/*
* -------------------------------------------
*               Translation
* -------------------------------------------
*/

export const manageNumberTranslationSelector = () =>
    createSelector(
        selectInt,
        (state: IIntState) => state.translation.pageSubscriberId.tabs.manageNumber,
    );


/*
* -------------------------------------------
*               Api
* -------------------------------------------
*/

const manageNumberMetaApiSelector = (subscriberId: string) =>
    manageNumberApi.endpoints.getManageNumberMeta.select(subscriberId);

export const manageNumberLabelsSelector = (subscriberId: string) => createSelector(
    manageNumberMetaApiSelector(subscriberId),
    meta => meta?.data?.labels ?? [],
);

export const manageNumberPositionSelectedSelector = (subscriberId: string) => createSelector(
    manageNumberMetaApiSelector(subscriberId),
    meta => meta?.data?.positionSelected,
);

export const manageNumberIsPositionChangeAvailableSelector = (subscriberId: string) => createSelector(
    manageNumberMetaApiSelector(subscriberId),
    meta => meta?.data?.actions?.includes(ESubscriberIdActions.positionChange),
);
